import Header from "../components/Header";
import TodayCard from "../components/TodayCard";
import WeekCard from "../components/WeekCard";
import MonthCalendar from "../components/MonthCalendar";

export default function Dashboard() {
  return (
    <div className="min-h-screen bg-[#0e0e0e] text-white p-4">
      <Header />

      <div className="max-w-6xl mx-auto space-y-20">
        <div className="grid grid-cols-1 lg:grid-cols-10 gap-6">
          <div className="lg:col-span-3">
            <TodayCard />
          </div>
          <div className="lg:col-span-7">
            <WeekCard />
          </div>
        </div>

        <MonthCalendar />
      </div>
    </div>
  );
}
